import React, { Fragment } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function Input_libas(props) {
  const { label, name, ...rest } = props;
  return (
    <Fragment>
      <div className="form-control-customed single_input">
        <div style={{ height: "23px" }}>
          <label htmlFor={name}>{label}</label>
        </div>
        <div style={{ clear: "both" }}></div>
        <div>
          <Field
            className="single_input_text"
            id={name}
            name={name}
            {...rest}
          />
          <ErrorMessage component={TextError} name={name} />
        </div>
      </div>

      {/* <div className="form-control-customed single_input">
        <label htmlFor={name}>{label}</label>
        <Field className="single_input_text" id={name} name={name} {...rest} />
        <ErrorMessage component={TextError} name={name} />
      </div> */}

      {/* <div className="form-control">
        <label htmlFor={name}>{label}</label>
        <Field id={name} name={name} {...rest} />
        <ErrorMessage component={TextError} name={name} />
      </div> */}
    </Fragment>
  );
}

export default Input_libas;
